import './components/share'

import './scss/st2/styles.scss'
